import { getRealm } from "@discovery/common-dplus/lib/realm";
import * as App from "@discovery/maestro";
import { Fold, Getter, Lens } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { array, boolean, number, optional, record, string, } from "@discovery/prelude/lib/data/validated";
import * as Configs from "@discovery/sonic-api-ng/lib/api/cms/configs";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { updateGlobalState } from "@discovery/common-dplus/lib/hooks";
import * as RTE from "fp-ts/ReaderTaskEither";
// ### TODO: This is needed for now to enable runtime validation of cms configs
const cmsConfigValidator = record({
    ads: optional(record({
        excludePackages: optional(array(string)),
        adUnitPathPrefix: optional(string),
        interstitials: optional(record({
            noOfTriggersBetweenPresentation: optional(number),
        })),
        shorts: optional(record({
            outstreamBannerAd: optional(record({
                adUnitPathSuffix: optional(string),
                interval: optional(number),
            })),
            outstreamVideoAd: optional(record({
                adUnitPathSuffix: optional(string),
                interval: optional(number),
            })),
        })),
        shortsVastTag: optional(string),
        vastTag: optional(string),
    })),
    featureToggles: optional(record({
        enableParentalLock: optional(boolean),
        enableAds: optional(boolean),
        emandateEnabled: optional(boolean),
    })),
    pageCollections: optional(record({
        home: optional(array(string)),
    })),
    parentalLock: optional(record({
        ageRestrictedChannels: optional(array(string)),
        minimumAge: optional(number),
    })),
    premiumPackages: optional(array(string)),
    payments: optional(record({
        disabled: optional(boolean),
    })),
    userAttributes: optional(record({
        lastContestID: optional(string),
        parentalLock: optional(string),
    })),
    pricing: optional(record({
        campaignsEnabled: optional(boolean),
        approvedPricePlans: optional(array(string)),
        preferredPricePlan: optional(record({
            id: optional(string),
            label: optional(string),
        })),
    })),
    decoratorFallbackMap: optional(record({
        default: optional(string),
        kids: optional(string),
        teens: optional(string),
    })),
    decoratorPrefixMap: optional(record({
        default: optional(string),
        kids: optional(string),
        teens: optional(string),
        mindblown: optional(string),
    })),
    affiliateMessaging: optional(record({
        displayForPartnerWithNames: optional(array(string)),
        intervalBetweenMessagesInDays: optional(number),
    })),
    collectionConfiguration: optional(record({
        shortsAllVideos: optional(string),
        shortsPromotedVideos: optional(string),
    })),
    externalLinks: optional(record({
        marketingAdTnC: optional(string),
        onlineDigitalAdOrderForm: optional(string),
        zendeskSupport: optional(string),
    })),
    eMandateDialog: optional(record({
        message: optional(string),
        title: optional(string),
    })),
    frameworkConfigurations: optional(record({
        blueshift: optional(record({
            environmentKey: optional(string),
        })),
    })),
    subscriptionCTA: optional(record({
        label: optional(string),
        url: optional(string),
    })),
});
const getDPlusConfig = Configs.Endpoints.getCustomConfig(cmsConfigValidator);
const _Config = Fold.compose(Fold.map((x) => Res.map((y) => y.data, x), Getter.of()), Res._Response(), Lens.prop("attributes"), Lens.prop("config"));
// ###
const setConfigIO = (configRes) => {
    const configM = Fold.preview(_Config, configRes);
    updateGlobalState(Lens.prop("configM"))((_oldConfigM) => configM);
    const adsM = M.chain((x) => x.ads, configM);
    const interstitialsM = M.chain((x) => x.interstitials, adsM);
    const noOfTriggersBetweenPresentationM = M.chain((x) => x.noOfTriggersBetweenPresentation, interstitialsM);
    const noOfTriggersBetweenPresentation = M.fromMaybe(noOfTriggersBetweenPresentationM, 0);
    try {
        localStorage.setItem("noOfTriggersBetweenPresentation", noOfTriggersBetweenPresentation.toString());
    }
    catch (e) {
        console.info(e);
    }
};
export const cmsConfigReq = App.chainMerge((realm) => {
    switch (realm.environment) {
        case "test":
            return App.chain((cfg) => RTE.fromIO(() => setConfigIO(cfg)), getDPlusConfig("client-config-pwa"));
        case "uat":
            return App.chain((cfg) => RTE.fromIO(() => setConfigIO(cfg)), getDPlusConfig("client-config-pwa-uat"));
        case "prod":
            return App.chain((cfg) => RTE.fromIO(() => setConfigIO(cfg)), getDPlusConfig("client-config-pwa"));
        default:
            return App.chain((cfg) => RTE.fromIO(() => setConfigIO(cfg)), getDPlusConfig("client-config-pwa"));
    }
}, getRealm);
